// @flow
import React from 'react';
import type { Node } from 'react';
import { useUid, useActiveId, useSetActiveId } from './context';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

type Props = $ReadOnly<{
    label: Node,
    children: Node
}>;

function Option({ label, children }: Props) {
    const uid = useUid();
    const activeId = useActiveId();
    const setActiveId = useSetActiveId();
    const isActive = activeId && uid === activeId;

    const handleClick = () => setActiveId(uid);

    return (
        <React.Fragment>
            {!activeId &&
                <ListItem button onClick={handleClick}>
                    <ListItemText primary={label} />
                </ListItem>
            }
            {isActive && children}
        </React.Fragment>
    );
}

export default Option;